import { render, staticRenderFns } from "./companyRef.vue?vue&type=template&id=5dc162e2&scoped=true&"
import script from "./companyRef.vue?vue&type=script&lang=js&"
export * from "./companyRef.vue?vue&type=script&lang=js&"
import style0 from "./companyRef.vue?vue&type=style&index=0&id=5dc162e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc162e2",
  null
  
)

export default component.exports